var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2449 12.848C16.8653 12.4923 17.6345 12.4344 18.2466 12.8811L30.1576 20.16C30.7448 20.5239 31.1088 21.1608 31.1088 21.8556C31.1088 22.5504 30.7448 23.1873 30.1576 23.5513L18.2466 30.8302C17.6345 31.2024 16.8653 31.2189 16.2449 30.8633C15.6163 30.5159 15.2275 29.8541 15.2275 29.1345V14.5023C15.2275 13.8571 15.6163 13.1954 16.2449 12.848Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 21.8418C0.667969 10.1501 10.1531 0.664978 21.8448 0.664978C33.5365 0.664978 43.0216 10.1501 43.0216 21.8418C43.0216 33.5335 33.5365 43.0186 21.8448 43.0186C10.1531 43.0186 0.667969 33.5335 0.667969 21.8418ZM21.8448 3.92295C11.9524 3.92295 3.92594 11.9494 3.92594 21.8418C3.92594 31.7342 11.9524 39.7606 21.8448 39.7606C31.7372 39.7606 39.7636 31.7342 39.7636 21.8418C39.7636 11.9494 31.7372 3.92295 21.8448 3.92295Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d63e08fb434b0b786f310ed2b79669fe.svg";
export { ForwardRef as ReactComponent };